import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { MessageCircle } from "lucide-react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Servizi from "./pages/Servizi";
import ChiSono from "./pages/ChiSono";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import Eventi from "./pages/Eventi";
import Contatti from "./pages/Contatti";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const AppShell = () => (
  <>
    <ScrollToTop />
    <div className="grain-overlay" aria-hidden="true" />
    <Navbar />
    <main>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/servizi" element={<Servizi />} />
        <Route path="/chi-sono" element={<ChiSono />} />
        <Route path="/eventi" element={<Eventi />} />
        <Route path="/contatti" element={<Contatti />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </main>
    <Footer />
    <a
      href="https://wa.me/393488598613?text=Ciao%20Agnese%2C%20vorrei%20informazioni%20su%20Artemisia"
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Scrivici su WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-sage text-cream shadow-[0_12px_32px_rgba(48,51,48,0.18)] transition-transform duration-500 hover:scale-110"
    >
      <MessageCircle className="h-6 w-6" />
    </a>
    <Toaster position="top-center" toastOptions={{ style: { background: '#37453E', color: '#F6F4EE', border: 'none', borderRadius: '1.5rem' } }} />
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
}

export default App;
